import { DisconnectSocialsButton } from '@/components/disconnect-socials/disconnect-socials';
import { fShortenNumber } from '@/utils/format-number';

import { Avatar, Box, Chip, Typography } from '@mui/material';

import { SocialIcon } from 'src/components/iconify';

export default function InstagramAccountsSection({ socialAccounts, session }) {
  console.log(socialAccounts, session);
  
  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SocialIcon width={24} icon="instagram" />
          Instagram Business Accounts
        </Typography>
        {/* {session && socialAccounts?.accounts?.length > 0 && <DisconnectSocialsButton />} */}
        {socialAccounts?.accounts?.length > 0 && <DisconnectSocialsButton />}
      </Box>

      {/* {session ? ( */}
      {true ? (
        socialAccounts?.accounts?.length > 0 ? (
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
              Connected Accounts ({socialAccounts.accounts.length})
            </Typography>
            {socialAccounts.accounts.map((account) => (
              <Box
                key={account.igUserId}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  mb: 1,
                }}
              >
                <Avatar
                  src={account?.profilePictureUrl}
                  alt={account.username}
                  sx={{ width: 48, height: 48 }}
                >
                  {account.username?.charAt(0)?.toUpperCase()}
                </Avatar>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle1" fontWeight={600}>
                    @{account.username}
                  </Typography>
                  {account.name && (
                    <Typography variant="body2" color="text.secondary">
                      {account.name}
                    </Typography>
                  )}
                  <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                    {account.followersCount && <Typography variant="caption">
                      {fShortenNumber(account.followersCount)} followers
                    </Typography>}
                    {account.followsCount && <Typography variant="caption">
                      {fShortenNumber(account.followsCount)} following
                    </Typography>}
                    {account.mediaCount && <Typography variant="caption">
                      {fShortenNumber(account.mediaCount)} posts
                    </Typography>}
                  </Box>
                  {account.page && (
                    <Typography variant="caption" color="text.secondary">
                      Connected via: {account.page.name}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  {account.accountType && <Chip label={account.accountType} size="small" variant="outlined" />}
                  {account.isVerified && <Chip label="Verified" size="small" color="primary" />}
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              p: 3,
              textAlign: 'center',
              backgroundColor: 'grey.50',
              borderRadius: 1,
              border: '1px dashed',
              borderColor: 'grey.300',
            }}
          >
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              No Instagram Business Accounts found
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Connect your Facebook account and ensure your Instagram account is set up as a
              Business account linked to a Facebook Page.
            </Typography>
          </Box>
        )
      ) : (
        <Box
          sx={{
            p: 3,
            textAlign: 'center',
            backgroundColor: 'grey.50',
            borderRadius: 1,
            border: '1px dashed',
            borderColor: 'grey.300',
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Please log in to view your Instagram accounts
          </Typography>
        </Box>
      )}
    </Box>
  );
}
